'use client'

import React from 'react'
import clsx from 'clsx'
import { COOKIE_KEYS } from '@/constants/storageKeys'
import styles from './styles.module.scss'

interface CookiePolicyDialogProps {
  onClose: () => void
}

const CookiePolicyDialog: React.FC<CookiePolicyDialogProps> = ({ onClose }) => {
  const handleClose = () => {
    const expirationDate = new Date()
    expirationDate.setFullYear(expirationDate.getFullYear() + 1)

    document.cookie = `${COOKIE_KEYS.READ_COOKIE_POLICY}=true; expires=${expirationDate.toUTCString()}; path=/`
    onClose()
  }

  return (
    <div className={styles.cookiePolicy}>
      <p>
        当社のウェブサイトは、サイトの利便性の向上を目的にクッキーを使用します。詳細は
        <a
          className={clsx('textLink', styles.nonHoverDecoration)}
          href='https://product.talent-book.jp/cookie-policy/'
          target='_blank'
          rel='noopener noreferrer'
        >
          クッキーポリシー
        </a>
        をご覧ください
      </p>
      <div className={clsx('buttonWrapper', styles.cookiePolicyButtons)}>
        <button
          className={clsx(styles.buttonBase, styles.round)}
          type='button'
          onClick={handleClose}
        >
          閉じる
        </button>
      </div>
    </div>
  )
}

export default CookiePolicyDialog
